// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input {
  height: auto !important;
}

.mbx03a70d85--Input {
  height: 56px;
}
.supplierSignupcontainer {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: #ebebeb;
}

.supplierSignupFormContainer {
  width: 550px;
  background-color: #ebebeb;
  margin-bottom: 40px;
  border-radius: 4px;
  padding: 20px;
}

.fileContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
}

.profilepicContainer {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
}
.profilepic {
  width: 150px;
  height: 150px;
  position: relative;
}
.profile-pic {
  width: 200px;
  max-height: 200px;
  display: inline-block;
}

.file-upload {
  display: none;
}
.circle {
  border-radius: 100% !important;
  overflow: hidden;
  width: 128px;
  height: 128px;
  border: 2px solid rgba(255, 255, 255, 0.2);
}
img {
  max-width: 100%;
  height: auto;
}
.p-image {
  position: absolute;
  bottom: 20px;
  right: 30px;
  width: 30px;
  height: 30px;
  color: #666666;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}
.p-image img {
  width: 100%;
}
.p-image:hover {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
/***** Profile CSS *****/
.profile-layout {
	margin: 0 auto;
	max-width: 800px;
}
.stepper {
  padding: 15px 0px 15px;
}
.profilepicContainer {
	display: block;
	margin: 20px auto;
	max-width: 140px;
	text-align: center;
}
.profilepic {
  width: 140px;
  height: 140px;
  position: relative;
  margin-bottom: 5px;
}
.circle {
  border-radius: 50% !important;
  width: 135px;
  height: 135px;
  border: 1px solid #d7d7d7;
	margin: 0 auto;
}
.profile-pic {
  width: 135px;
  max-height: 135px;
  object-fit: cover;
  border-radius: 50%;
}
.file-upload {
  display: none;
}
img {
  max-width: 100%;
  height: auto;
}
.p-image {
  position: absolute;
  bottom: 20px;
  right: 5px;
  width: 30px;
  height: 30px;
  background: rgb(255 255 255);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 0px 4px rgb(0 0 0 / 50%);
}
.p-image img {
  width: 20px;
}
.p-image:hover {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}
.upload-button {
  font-size: 1.2em;
}

.upload-button:hover {
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  color: #999;
}
.bottom-buttons {
	border-top: 1px solid #e0e0e0;
	padding-top: 15px;
	display: flex;
	align-items: center;
	justify-content: end;
	gap: 15px;
}
.nextButton, .backButton, .updateButton, .updateImage {
	background-color: #000 !important;
	color: #fff !important
}
.stepper .MuiStepLabel-horizontal span svg.MuiStepIcon-root {
  display: inline-block;
}
.stepper .MuiStepLabel-horizontal span {
  display: block;
  text-align: center;
  padding: 0px;
}
.stepper .MuiStepLabel-horizontal {
  display: block;
  text-align: center;
}
@media (max-width: 767px) {
  .stepper .MuiStepLabel-horizontal span:last-child {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/auth/updateProfile/UpdateProfile.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;AACA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4DAA4D;AAC9D;AACA;EACE,WAAW;AACb;AACA;EACE,4DAA4D;EAC5D,eAAe;AACjB;AACA,wBAAwB;AACxB;CACC,cAAc;CACd,gBAAgB;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;CACC,cAAc;CACd,iBAAiB;CACjB,gBAAgB;CAChB,kBAAkB;AACnB;AACA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,aAAa;EACb,yBAAyB;CAC1B,cAAc;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,WAAW;AACb;AACA;EACE,4DAA4D;EAC5D,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,4DAA4D;EAC5D,WAAW;AACb;AACA;CACC,6BAA6B;CAC7B,iBAAiB;CACjB,aAAa;CACb,mBAAmB;CACnB,oBAAoB;CACpB,SAAS;AACV;AACA;CACC,iCAAiC;CACjC;AACD;AACA;EACE,qBAAqB;AACvB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;IACE,aAAa;EACf;AACF","sourcesContent":[".css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input {\n  height: auto !important;\n}\n\n.mbx03a70d85--Input {\n  height: 56px;\n}\n.supplierSignupcontainer {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: #ebebeb;\n}\n\n.supplierSignupFormContainer {\n  width: 550px;\n  background-color: #ebebeb;\n  margin-bottom: 40px;\n  border-radius: 4px;\n  padding: 20px;\n}\n\n.fileContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 10px;\n}\n\n.profilepicContainer {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 15px;\n}\n.profilepic {\n  width: 150px;\n  height: 150px;\n  position: relative;\n}\n.profile-pic {\n  width: 200px;\n  max-height: 200px;\n  display: inline-block;\n}\n\n.file-upload {\n  display: none;\n}\n.circle {\n  border-radius: 100% !important;\n  overflow: hidden;\n  width: 128px;\n  height: 128px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n}\nimg {\n  max-width: 100%;\n  height: auto;\n}\n.p-image {\n  position: absolute;\n  bottom: 20px;\n  right: 30px;\n  width: 30px;\n  height: 30px;\n  color: #666666;\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n}\n.p-image img {\n  width: 100%;\n}\n.p-image:hover {\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n/***** Profile CSS *****/\n.profile-layout {\n\tmargin: 0 auto;\n\tmax-width: 800px;\n}\n.stepper {\n  padding: 15px 0px 15px;\n}\n.profilepicContainer {\n\tdisplay: block;\n\tmargin: 20px auto;\n\tmax-width: 140px;\n\ttext-align: center;\n}\n.profilepic {\n  width: 140px;\n  height: 140px;\n  position: relative;\n  margin-bottom: 5px;\n}\n.circle {\n  border-radius: 50% !important;\n  width: 135px;\n  height: 135px;\n  border: 1px solid #d7d7d7;\n\tmargin: 0 auto;\n}\n.profile-pic {\n  width: 135px;\n  max-height: 135px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.file-upload {\n  display: none;\n}\nimg {\n  max-width: 100%;\n  height: auto;\n}\n.p-image {\n  position: absolute;\n  bottom: 20px;\n  right: 5px;\n  width: 30px;\n  height: 30px;\n  background: rgb(255 255 255);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 0px 4px rgb(0 0 0 / 50%);\n}\n.p-image img {\n  width: 20px;\n}\n.p-image:hover {\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n.upload-button {\n  font-size: 1.2em;\n}\n\n.upload-button:hover {\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  color: #999;\n}\n.bottom-buttons {\n\tborder-top: 1px solid #e0e0e0;\n\tpadding-top: 15px;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: end;\n\tgap: 15px;\n}\n.nextButton, .backButton, .updateButton, .updateImage {\n\tbackground-color: #000 !important;\n\tcolor: #fff !important\n}\n.stepper .MuiStepLabel-horizontal span svg.MuiStepIcon-root {\n  display: inline-block;\n}\n.stepper .MuiStepLabel-horizontal span {\n  display: block;\n  text-align: center;\n  padding: 0px;\n}\n.stepper .MuiStepLabel-horizontal {\n  display: block;\n  text-align: center;\n}\n@media (max-width: 767px) {\n  .stepper .MuiStepLabel-horizontal span:last-child {\n    display: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
